import { THEME_TYPES } from "../../default/activities/Preview";

export const SEK_THEME_TYPES = [
    ...THEME_TYPES
]
